<div class="row">
  <div class="col-lg-6" *ngIf="separated || cash">
    <div class="row h-100">
      <div class="col-lg-12">
        <div class="mb-2">
          <img
            *ngIf="!esCotizacionHotSale(fecha)"
            [src]="
              centro == 'CHIHUAHUA'
                ? 'assets/img/banner_contado_01.jpg'
                : 'assets/img/banner_contado_02.jpg'
            "
            class="card-img-top"
            alt="... "
          />

          <!-- <img *ngIf="esCotizacionHotSale(fecha)"
                        [src]="centro =='CHIHUAHUA' ? 'assets/hotsale/banner_hs_mp_contado.jpg' : 'assets/hotsale/banner_hs_vm_contado.jpg' "
                        class="card-img-top " alt="... "> -->
          <img
            *ngIf="esCotizacionHotSale(fecha)"
            [src]="
              centro == 'CHIHUAHUA'
                ? 'assets/fdh/50pesito_566.png'
                : 'assets/fdh/50pesito_566[1].png'
            "
            class="card-img-top"
            alt="... "
          />
        </div>
        <div class="card-wrapper" *ngFor="let item of orderContent.cartItems">
          <div
            class="card h-100 border-card-contado"
            *ngIf="item.precios[0].tipo_venta == 2"
          >
            <div class="text-center parent-img">
              <img
                class="card-img-top card-img-item img-fluid"
                src="http://www.soporteroga.com/Images_ROGA/{{
                  item.imgArticulos
                }} "
                alt="Card image cap "
                (error)="onImgError($event)"
              />
              <img
                src="/assets/hotsale/hotsale_logo.png"
                alt="logo_buen_fin"
                *ngIf="
                  (item.idControlFacturacion === 28 ||
                    item.idControlFacturacion === 39) &&
                  esBF
                "
                class="child-img-bf"
              />
              <img
                *ngIf="item.idControlFacturacion === 28"
                src="/assets/bf/5_por.png"
                alt="logo_5"
                class="child-img-5"
              />
              <!-- <img *ngIf="item.idControlFacturacion===39 || tieneEsquemaBuenFin(item.idControlFacturacion,item.otrosEsquemas) "
                                src="/assets/bf/clock.png" alt="logo_96" class="child-img-contra" /> -->
            </div>
            <div class="card-body contado">
              <h5 class="card-title b-text card-title-text">
                {{ item.sku }} - {{ item.precios[0].linea_articulo }}
              </h5>
              <h5
                class="card-title b-text card-title-text"
                *ngIf="item.unidades > 1"
              >
                # Articulos {{ item.unidades }}
              </h5>
              <div class="card-text">
                <span class="purchase-plan-text">{{
                  fixOrtography(item.controlFacturacion)
                }}</span
                ><br />
                <div *ngIf="item.precios[0].descuento_lu > 0">
                  <span
                    >Págo único de
                    {{
                      (item.precios[0].precio * item.precios[0].descuento_lu +
                        item?.precioInstalacion) *
                        item.precios[0].unidades | currency
                    }}</span
                  ><br />
                </div>
                <div *ngIf="item.precios[0].descuento_lu === 0">
                  <span
                    >Págo único de
                    {{
                      (item.precios[0].precio + item?.precioInstalacion) *
                        item.precios[0].unidades | currency
                    }}</span
                  ><br />
                </div>
                <!--                                 <span *ngIf="item.precios[0].idControlFacturacion==2 ">¡Congela con {{ 50 |currency}} pesos el precio de tu artículo a 16 semanas!</span>
                                <span *ngIf="item.precios[0].idControlFacturacion !=2 ">¡Congela con {{ 50 |currency}} pesos el precio de tu artículo a 20 semanas!</span><br> -->
              </div>
              <ul class="price-list">
                <li>
                  <span *ngIf="item.esLU" class="subtext"
                    >* Este producto tiene descuento especial dependiendo las
                    condiciones del artículo.</span
                  >
                </li>
                <!-- <li> <span *ngIf="item.idControlFacturacion===28 || item.idControlFacturacion===39 " class="subtext">* Promoción 30 Aniversario, Valido por el mes de {{restService.mes}} 2022.</span>
                                </li> -->
                <li>
                  <span
                    *ngIf="
                      (item.idControlFacturacion === 28 ||
                        item.idControlFacturacion === 39) &&
                      esBF
                    "
                    class="subtext"
                  >
                    {{ strLeyendaBf }}</span
                  >
                </li>
                <li>
                  <span *ngIf="item.precioInstalacion > 0" class="subtext"
                    >* Incluye instalación</span
                  >
                </li>
              </ul>
            </div>
            <button
              *ngIf="item.video != 'NA'"
              type="button"
              class="btn btn-light"
              data-toggle="modal"
              data-target="#exampleModal"
              (click)="onClickOpenVideo(item.video)"
            >
              ¡Ver vídeo del producto!
            </button>
          </div>
        </div>

        <img
          *ngIf="esCotizacionBf(cotizacion.submitedAt) && teneApartado()"
          [src]="
            cotizacion.zone == 'CHIHUAHUA'
              ? 'assets/fdh/50pesito_566.png'
              : 'assets/fdh/50pesito_566[1].png'
          "
          class="card-img-top"
          alt="... "
        />

        <div class="card-wrapper" *ngFor="let item of orderContent.cartItems">
          <div
            class="card h-100 border-card-apartado"
            *ngIf="item.precios[0].tipo_venta == 6"
          >
            <div class="text-center bf-5">
              <img
                class="card-img-top card-img-item img-fluid"
                src="http://www.soporteroga.com/Images_ROGA/{{
                  item.imgArticulos
                }} "
                alt="Card image cap "
                (error)="onImgError($event)"
              />

              <img
                src="/assets/bf/logobuenfin.png"
                *ngIf="item.idControlFacturacion === 29 && esBF"
                class="child-img-bf"
              />
            </div>
            <div class="card-body apartado">
              <h5 class="card-title b-text card-title-text">
                {{ item.sku }} - {{ item.precios[0].linea_articulo }}
              </h5>
              <h5
                class="card-title b-text card-title-text"
                *ngIf="item.unidades > 1"
              >
                # Articulos {{ item.unidades }}
              </h5>

              <div class="card-text">
                <span class="purchase-plan-text">{{
                  fixOrtography(item.precios[0].nombre_control_facturacion)
                }}</span
                ><br />
                <ul class="price-list" *ngFor="let price of item.precios">
                  <div *ngIf="price.descuento_lu > 0">
                    <li *ngIf="item.precios.indexOf(price) < 1">
                      Precio {{ item.precios[0].nombre_control_facturacion }}:
                      {{
                        roundUp(
                          (price.precio * price.descuento_lu +
                            item?.precioInstalacion) *
                            price.unidades
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}
                    </li>

                    <li *ngIf="item.precios.indexOf(price) > 0">
                      Precio
                      {{
                        roundUp(
                          (price.precio * price.descuento_lu +
                            item?.precioInstalacion) *
                            price.unidades
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}
                      Apártalo a {{ price.plazo * 2 }} Pagos Semanales de
                      {{
                        roundUp(
                          ((price.precio + item?.precioInstalacion) *
                            price.unidades -
                            price.enganche) /
                            (price.plazo * 2)
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}, Ahorras
                      {{
                        roundUp(
                          (item.precios[0].precio - price.precio) *
                            price.unidades
                        ) | currency : "USD" : "symbol" : "1.0-0"
                      }}
                    </li>
                  </div>
                  <div *ngIf="price.descuento_lu === 0">
                    <li *ngIf="item.precios.indexOf(price) < 1">
                      Precio {{ item.precios[0].nombre_control_facturacion }}:
                      {{
                        (price.precio + item?.precioInstalacion) *
                          price.unidades | currency
                      }}
                    </li>
                    <li *ngIf="item.precios.indexOf(price) > 0">
                      Precio
                      {{
                        (price.precio + item?.precioInstalacion) *
                          price.unidades | currency
                      }}
                      Apártalo a {{ price.plazo * 2 }} Pagos Semanales de
                      {{
                        ((price.precio + item?.precioInstalacion) *
                          price.unidades -
                          price.enganche) /
                          (price.plazo * 2) | currency
                      }}, Ahorras
                      {{
                        (item.precios[0].precio - price.precio) * price.unidades
                          | currency
                      }}
                    </li>
                  </div>
                </ul>
                <ul class="price-list">
                  <li>
                    <span *ngIf="item.esLU" class="subtext"
                      >* Este producto tiene descuento especial dependiendo las
                      condiciones del artículo.</span
                    >
                  </li>
                  <!-- <li><span *ngIf="item.idControlFacturacion===29" class="subtext">* Promoción 30
                                            Aniversario, Valido por el mes de {{restService.mes}} 2022.</span></li> -->
                  <li>
                    <span
                      *ngIf="item.idControlFacturacion === 29 && esBF"
                      class="subtext"
                      >{{ strLeyendaBf }}</span
                    >
                  </li>

                  <li>
                    <span *ngIf="item.precioInstalacion > 0" class="subtext"
                      >* Incluye instalación</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <button
              *ngIf="item.video != 'NA'"
              type="button"
              class="btn btn-light"
              data-toggle="modal"
              data-target="#exampleModal"
              (click)="onClickOpenVideo(item.video)"
            >
              ¡Ver vídeo del producto!
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 align-self-end my-3">
        <img src="assets/img/footer_cash.jpg" class="card-img-top" alt="..." />
      </div>
    </div>
  </div>
  <div class="col-lg-6" *ngIf="credit">
    <div class="row h-100">
      <div class="col-lg-12">
        <div class="mb-2">
          <img
            *ngIf="!esCotizacionBf(fecha)"
            [src]="
              centro == 'CHIHUAHUA'
                ? 'assets/img/banner_credito_01.jpg'
                : 'assets/img/banner_credito_02.jpg'
            "
            class="card-img-top"
            alt="..."
          />

          <!-- <img *ngIf="esCotizacionBf(fecha)"
                        [src]="centro =='CHIHUAHUA' ? 'assets/hotsale/banner_hs_mp_credito.jpg' : 'assets/hotsale/banner_hs_vm_credito.jpg' "
                        class="card-img-top " alt="... "> -->
          <img
            *ngIf="esCotizacionBf(fecha)"
            [src]="
              centro == 'CHIHUAHUA'
                ? 'assets/fdh/descuento_566[1].png'
                : 'assets/fdh/desceunto_566.png'
            "
            class="card-img-top"
            alt="... "
          />
        </div>

        <div class="card-wrapper" *ngFor="let item of orderContent.cartItems">
          <!-- CREDITO = 4 -->
          <div
            class="card h-100 border-card-credito"
            *ngIf="item.precios[0].tipo_venta == 4"
          >
            <div class="text-center">
              <img
                class="card-img-top card-img-item img-fluid"
                src="http://www.soporteroga.com/Images_ROGA/{{
                  item.imgArticulos
                }}"
                alt="Card image cap"
                (error)="onImgError($event)"
              />
              <img
                src="/assets/bf/logobuenfin.png"
                *ngIf="item.idControlFacturacion === 59 && esBF"
                class="child-img-bf"
              />
              <!-- <img src="/assets/bf/logobuenfin.png" *ngIf=" item.idControlFacturacion===40 && esBF"
                            class="child-img-bf">
                            <img src="/assets/bf/logobuenfin.png" *ngIf=" item.idControlFacturacion===74 && esBF"
                            class="child-img-bf"> -->
            </div>
            <div class="card-body credito">
              <div class="">
                <h5 class="card-title b-text card-title-text">
                  {{ item.sku }} - {{ item.precios[0].linea_articulo }}
                </h5>
                <h5
                  class="card-title b-text card-title-text"
                  *ngIf="item.unidades > 1"
                >
                  # Articulos {{ item.unidades }}
                </h5>
              </div>
              <div class="card-text">
                <span class="purchase-plan-text"
                  >{{
                    fixOrtography(item.precios[0].nombre_control_facturacion)
                  }} </span
                ><br />
                <ul class="price-list" *ngFor="let price of item.precios">
                  <div *ngIf="price.descuento_lu > 0">
                    <li *ngIf="item.precios[0].precio - price.precio == 0">
                      {{ price.plazo * 2 }} Pagos Semanales de
                      {{
                        ((price.precio * price.descuento_lu +
                          item?.precioInstalacion) *
                          price.unidades -
                          price.enganche) /
                          (price.plazo * 2) | currency
                      }}
                    </li>

                    <li *ngIf="item.precios[0].precio - price.precio > 0">
                      {{ price.plazo * 2 }} Pagos Semanales de
                      {{
                        ((price.precio * price.descuento_lu +
                          item?.precioInstalacion) *
                          price.unidades -
                          price.enganche) /
                          (price.plazo * 2) | currency
                      }}, Ahorras
                      {{
                        (item.precios[0].precio * item.precios[0].descuento_lu -
                          price.precio * price.descuento_lu) *
                          price.unidades | currency
                      }}
                    </li>
                  </div>
                  <div *ngIf="price.descuento_lu === 0">
                    <li *ngIf="item.precios[0].precio - price.precio == 0">
                      {{ price.plazo * 2 }} Pagos Semanales de
                      {{
                        ((price.precio + item?.precioInstalacion) *
                          price.unidades -
                          price.enganche) /
                          (price.plazo * 2) | currency
                      }}
                    </li>

                    <li *ngIf="item.precios[0].precio - price.precio > 0">
                      {{ price.plazo * 2 }} Pagos Semanales de
                      {{
                        ((price.precio + item?.precioInstalacion) *
                          price.unidades -
                          price.enganche) /
                          (price.plazo * 2) | currency
                      }}, Ahorras
                      {{
                        (item.precios[0].precio - price.precio) * price.unidades
                          | currency
                      }}
                    </li>
                  </div>
                </ul>
                <ul class="price-list">
                  <li>
                    <span class="subtext"
                      >* Pagos semanales calculados con
                      {{ item.precios[0].enganche | currency }} pesos de
                      enganche.</span
                    >
                  </li>
                  <li>
                    <span *ngIf="item.esLU" class="subtext"
                      >* Este producto tiene descuento especial dependiendo las
                      condiciones del artículo.</span
                    >
                  </li>
                  <!-- <li> <span *ngIf="item.idControlFacturacion===35 || item.idControlFacturacion===57 "
                                            class="subtext">* Promoción 30 Aniversario, Valido por el mes de
                                            {{restService.mes}} 2022.</span>
                                    </li> -->
                  <li>
                    <span
                      *ngIf="item.idControlFacturacion === 59 && esBF"
                      class="subtext"
                    >
                      {{ strLeyendaBf }}</span
                    >
                  </li>
                  <li>
                    <span *ngIf="item.precioInstalacion > 0" class="subtext"
                      >* Incluye instalación</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <button
              *ngIf="item.video != 'NA'"
              type="button"
              class="btn btn-light"
              data-toggle="modal"
              data-target="#exampleModal"
              (click)="onClickOpenVideo(item.video)"
            >
              ¡Ver vídeo del producto!
            </button>
          </div>
        </div>
      </div>

      <div class="col-lg-12 align-self-end my-3">
        <div>
          <img
            src="assets/img/footer_credit.jpg"
            class="card-img-top"
            alt="..."
          />
        </div>
      </div>
    </div>
  </div>
</div>

<app-video-modal
  *ngIf="openVideo"
  [ytSrc]="videoSleccionado"
  (closeModal)="onCloseVideo($event)"
></app-video-modal>
